import React from 'react';
import { Link } from 'react-router-dom';
import { Seo, ContentAdSlot } from '../shared';
import { companyDetails } from '../../helpers';

const InfoPage = () => (
	<div className="container px-md-4 py-md-4 page">
		<Seo
			title="About Us"
			path="/about"
			description="Visit All Nepal publishes original Nepal travel guides — guided treks, destinations, festivals, visa help, and trip planning — plus booking for group departures and private tours."
		/>
		<div className="about-page card border-0 shadow-sm p-4 p-md-5">
			<h1 className="title mb-4">About Visit All Nepal</h1>

			<p className="lead text-secondary">
				Visit All Nepal is an independent Nepal travel guide and booking platform. We publish step-by-step
				guided journeys for major treks, destination guides, festival calendars, visa and permit help, and
				practical planning content — then help you book group departures or private tours when you are ready to travel.
			</p>

			<ContentAdSlot layout="about" className="adsense-unit--in-content my-4" />

			<hr className="my-4" />

			<h2 className="h5 text-primary mt-4 mb-2">What we publish</h2>
			<p>
				Our editorial focus is original, practical information for people planning a trip to Nepal. That includes:
			</p>
			<ul className="about-list pl-4">
				<li><strong>Guided journeys</strong> — multi-step trek planners (Everest Base Camp, Annapurna Circuit, Langtang, and dozens more) covering visa, flights, permits, packing, day-by-day routes, safety, and budgets.</li>
				<li><strong>Destinations &amp; places</strong> — regional guides across Nepal&apos;s provinces, districts, temples, and national parks.</li>
				<li><strong>Festivals &amp; culture</strong> — when major Nepali festivals happen, what they mean, and how travelers can experience them respectfully.</li>
				<li><strong>Trip planning hubs</strong> — visa requirements, arrival logistics, transportation, seasonal advice, trekking basics, and safety.</li>
			</ul>
			<p>
				Explore the full library from our{' '}
				<Link to="/journeys">journeys index</Link>,{' '}
				<Link to="/festivals">festivals hub</Link>,{' '}
				<Link to="/trekking">trekking guides</Link>, or the{' '}
				<Link to="/guides">travel guides directory</Link>.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">Booking with us</h2>
			<p>
				When you are ready to travel, you can reserve a seat on a{' '}
				<Link to="/group-trips">group departure</Link>, request a{' '}
				<Link to="/packages">private tour</Link> on your own dates, or browse{' '}
				<Link to="/shared-rentals">shared intercity rides</Link>. Every booking is handled by Visit All Nepal;
				we coordinate logistics and assign verified local operators internally.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">Who we are</h2>
			<p>
				Visit All Nepal is operated by a Nepal-based team that builds travel content and coordinates bookings for
				international visitors. We are not a faceless listing site — our guides are written for real trip planning,
				and our support team answers questions before and during your journey.
			</p>

			<h2 className="h5 text-primary mt-4 mb-2">Contact</h2>
			<p className="mb-1">
				Email:{' '}
				<a href={`mailto:${companyDetails.email}`}>{companyDetails.email}</a>
			</p>
			<p className="mb-1">
				Phone / WhatsApp:{' '}
				<a href={`tel:${companyDetails.code}${companyDetails.contact}`}>
					{companyDetails.code} {companyDetails.contact}
				</a>
			</p>
			<p>
				Questions about a booking or guide? Visit our{' '}
				<Link to="/support">customer support</Link> page.
			</p>

			<hr className="my-4" />

			<div className="d-flex flex-wrap mt-4">
				<Link to="/journeys" className="btn btn-primary mr-2 mb-2">
					Browse guided journeys
				</Link>
				<Link to="/support" className="btn btn-outline-secondary mr-2 mb-2">
					Customer support
				</Link>
				<Link to="/privacy" className="btn btn-outline-secondary mb-2">
					Privacy policy
				</Link>
			</div>
		</div>
	</div>
);

export default InfoPage;
